//@flow
import * as React from 'react';
import { connect } from 'react-redux';
import * as Redux from 'redux';
import styled from 'styled-components';
import { translate } from "react-i18next";
import DefaultButton from './../../components/DefaultButton';
import GhostButton from './../../components/GhostButton';
import TextInput from './../../components/TextInput';
import MainPageContainer from './../../components/MainPageContainer';
import loading from './../../utilities/loading';
import messageManager from './../../utilities/messageManager';

import {
    AXIOS_INSTANCE,
} from './../../types/auth';

const ButtonWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    margin: 15px;
`;

const FlexForm = styled.form`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

type State = {
    login: string,
    newPassword: string,
    repeatedNewPassword: string,
    invalidPassword: boolean,
    invalidLogin: boolean,
    resetButtonDisabled: boolean,
};


type Props = {
    axiosInstance: any,
    t: (text: string) => {},
}

export class SignIn extends React.Component<Props, State> {
    constructor(): void {
        super();

        this.state = {
            login: '',
            invalidLogin: false,
            newPassword: '',
            repeatedNewPassword: '',
            invalidPassword: false,
            invalidRepeatPassword: false,
            resetButtonDisabled: false,
        };
    }

    handleSubmit() {
        const { BASE_URL, axiosInstance, t } = this.props;
        const { login, newPassword, } = this.state;

        this.validateForm((formInvalid) => {
            if (!formInvalid) {
                const url = window.location.href;
                const token = url.slice(url.indexOf('token=') + 6);

                loading.start();
                this.setState({ resetButtonDisabled: true })

                axiosInstance.post(`${BASE_URL}account/reset-password`, {
                    login: login,
                    password: newPassword,
                    token: token,
                })
                    .then((response) => {
                        messageManager.show({
                            text: t('Password reset'),
                            type: 'info',
                        })

                        loading.stop();
                        this.setState({ resetButtonDisabled: false })
                        setTimeout(() => {
                            window.location.replace('./#/signin')
                        })
                    })
                    .catch((error) => {
                        messageManager.show({
                            text: t(error.response.data),
                            type: 'error',
                        })
                        loading.stop();
                        this.setState({ resetButtonDisabled: false })
                    })
            }
        })
    }

    validateForm(callback) {
        const { newPassword, repeatedNewPassword, login, } = this.state;
        let invalidPassword = false,
            invalidLogin = false,
            invalidRepeatPassword = false;
        if (newPassword.length < 6)
            invalidPassword = true;
        if (newPassword !== repeatedNewPassword)
            invalidRepeatPassword = true;
        if (login === "")
            invalidLogin = true;
        this.setState(
            {
                invalidPassword: invalidPassword,
                invalidLogin: invalidLogin,
                invalidRepeatPassword: invalidRepeatPassword
            },
            callback(invalidPassword || invalidRepeatPassword || invalidLogin));
    }

    render(): React.Node {
        const {
            login,
            newPassword,
            repeatedNewPassword,
            invalidPassword,
            invalidRepeatPassword,
            invalidLogin,
            resetButtonDisabled,
        }: State = this.state;
        const { t }: Props = this.props;
        return (
            <MainPageContainer>
                <FlexForm onSubmit={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.handleSubmit();
                }}>
                    <input type="submit" value="Submit" style={{ display: 'none' }} />
                    <TextInput
                        style={{ width: '265px', margin: '5px' }}
                        type="email"
                        placeholder="example@mail.com"
                        autoComplete="email"
                        required
                        name="email"
                        value={login}
                        tip={t('Enter email associated with your account')}
                        onChange={event => {
                            this.setState({ login: event.target.value });
                        }}
                        invalid={invalidLogin}
                        onBlur={() => {
                            if (login === '') {
                                this.setState({
                                    invalidLogin: true,
                                })
                            }
                            else {
                                this.setState({
                                    invalidLogin: false,
                                })
                            }
                        }} />
                    <TextInput
                        style={{ width: '265px', margin: '5px' }}
                        type="password"
                        placeholder={t('new password')}
                        required
                        name="newPassword"
                        value={newPassword}
                        tip={t("Type 6 characters or more")}
                        invalid={invalidPassword}
                        onChange={event => {
                            this.setState({ newPassword: event.target.value });
                        }}
                        onBlur={event => {
                            if (newPassword.length < 6)
                                this.setState({ invalidPassword: true })
                            else
                                this.setState({ invalidPassword: false })
                        }} />

                    <TextInput
                        style={{ width: '265px', margin: '5px' }}
                        type="password"
                        placeholder={t('repeat new password')}
                        required
                        name="repeatedNewPassword"
                        value={repeatedNewPassword}
                        tip={t("Type your password again")}
                        onChange={event => {
                            this.setState({ repeatedNewPassword: event.target.value });
                        }}
                        invalid={invalidRepeatPassword}
                        onBlur={() => {
                            if (repeatedNewPassword !== newPassword) {
                                this.setState({
                                    invalidRepeatPassword: true,
                                })
                            }
                            else {
                                this.setState({
                                    invalidRepeatPassword: false,
                                })
                            }
                        }}
                    />

                    <ButtonWrapper>
                        <GhostButton
                            onClick={() => {
                                window.location.replace('./#/signin')
                            }}
                            style={{
                                height: '30px',
                                width: '50px',
                                display: 'flex',
                                marginRight: '5px',
                            }}>
                            {`${t('Back')}`}
                        </GhostButton>
                        <DefaultButton
                            style={{
                                width: '50px',
                                padding: '5px',
                            }}
                            disabled={resetButtonDisabled}
                            onClick={(e) => {
                                this.handleSubmit();
                            }}>
                            {t('Reset')}
                        </DefaultButton>
                    </ButtonWrapper>
                </FlexForm>
            </MainPageContainer >
        );
    }
};

const mapStateToProps = state => ({
    [AXIOS_INSTANCE]: state.auth.get(AXIOS_INSTANCE),
    BASE_URL: state.domainProperties.get('BASE_URL'),
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
}, dispatch);

export default translate("translations")(connect(mapStateToProps, mapDispatchToProps)(SignIn));


// WEBPACK FOOTER //
// ./src/containers/resetPassword/ResetPassword.jsx